"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsCleanup = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var LastEditedCleanup_1 = require("./LastEditedCleanup");
var c = (0, BemBuilder_1.default)("reports-cleanup-popover");
function ReportsCleanup(_a) {
    var cleanupFilters = _a.cleanupFilters, setCleanupFilters = _a.setCleanupFilters;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(LastEditedShift, { lastEdited: cleanupFilters.lastEdited, onChange: function (newValue) { return setCleanupFilters(__assign(__assign({}, cleanupFilters), { lastEdited: newValue })); } }),
        react_1.default.createElement("div", { className: c("further-actions") },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Clean up further actions"),
            react_1.default.createElement(kaleidoscope_1.Text, { element: "p", size: "xs" }, "\u2022 Archive Draft and Live Pages that do not apply to the selected time period in the pages dashboard"),
            react_1.default.createElement(kaleidoscope_1.Text, { element: "p", size: "xs" }, "\u2022 Refine Collection filters in Reporting settings"))));
}
exports.ReportsCleanup = ReportsCleanup;
function LastEditedShift(_a) {
    var lastEdited = _a.lastEdited, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: c("last-edited-filter") },
        react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Clean up quick filters"),
        react_1.default.createElement(LastEditedCleanup_1.LastEditedCleanup, { onChange: onChange, initialValue: lastEdited })));
}
